export default function ContentSixth({ verticalTabsState }) {
  return (
    <div
      className={`content-6 overflow-hidden max-h-0 transition-opacity duration-[0.2s] ease-linear ${
        verticalTabsState === 6
          ? "max-h-[5000px] opacity-100 z-2"
          : "opacity-0 max-h-0 z-0"
      }`}
    >
      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Manage Your Hiring Process</strong>
      </h2>

      <p className="text-[18px] mb-[25px] leading-[28px]">
        Organize your vacancies job applications
      </p>

      <p className="text-[16px] mb-[20px]">
        Set up your job board, promote your job listings and easily keep track
        of submitted applications. Follow every applicant and build a database
        of skills and profiles with indexed documents. No need to outsource your
        recruitment - handle everything internally in a simple and professional
        way.
      </p>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Create your own hiring strategies.
      </p>

      <p className="text-[16px] mb-5">
        Use the kanban view and customize the steps of your recruitments
        process: pre-qualification, first interview, second interview,
        negotiation, etc. Get accurate statistics on your recruitment pipeline.
      </p>

      <p className="text-[16px] mb-5">
        Use reports to compare the performance of postings you have made on
        different external job boards and easily change your strategy and
        recruitment plan based on the results.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Successfully Manage our Employees</strong>
      </h2>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Centralize all your HR information.
      </p>

      <p className="mb-5 text-[16px]">
        Oversee all important information for each department at a glance.
        Restrict visibility of sensitive information to just HR managers, or
        make other information public for all employees to see such as employee
        directory. Receive alerts for any new leave requests, allocation
        requests, applications, appraisals, and more.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Track Time & Attendance</strong>
      </h2>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Weekly or monthly timesheets with optional attendance tracking.
      </p>

      <p className="mb-5 text-[16px]">
        Keep track of the employee hours worked and sort by project, client, or
        tasks. Easily access statistics to record and analyze timesheets as well
        as check each employee's attendance. Integrated accounting automatically
        posts reports based on time spent in projects providing real-time data.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Recruit Top Talents</strong>
      </h2>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Streamline your hiring process.
      </p>

      <p className="mb-5 text-[16px]">
        Set up a job board to post open positions in just a few clicks and
        easily keep track of submitted applications.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Online Expense Management</strong>
      </h2>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Easily manage employee expenses.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Save Time On Expense Reports</strong>
      </h2>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Everything in one place.
      </p>

      <p className="mb-5 text-[16px]">
        Managing your employees' daily expenses has never been easier. Whether
        it's travel expenses, office supplies, or any other employee
        expenditure, access all receipts and expense submissions from your
        Expenses dashboard and create, validate, or refuse them in just a click.
        No need to download a specialized software to maintain expense records.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Top Losing Receipts</strong>
      </h2>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Upload all receipts directly into the expense record.
      </p>

      <p className="mb-5 text-[16px]">
        Employees can easily attach copies of their receipts directly to an
        expense record to avoid losing them. Add attachments on the go with any
        mobile device by taking a picture of the receipt and sending to a
        designated email address. Save time and increase efficiency by keeping a
        clean and complete record of all expenses.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Manage Expenses Per Team</strong>
      </h2>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Have a clear overview of a team’s expenditures.
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Leave Management</strong>
      </h2>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Simplified tracking for employee vacation and sick days.
      </p>

      <div className="flex mb-5">
        <p className="text-[16px] w-[30%] px-[15px]">
          <strong>Employees</strong> enter their requests (paid time off, sick
          leave, etc).
        </p>

        <p className="text-[16px] w-[30%] px-[15px]">
          <strong>Mangers</strong> decide to either approve or refuse time off
          requests.
        </p>

        <p className="text-[16px] w-[30%] px-[15px]">
          Notification is sent to the employee and their{" "}
          <strong>calendar</strong> is updated automatically.
        </p>
      </div>
    </div>
  );
}
